import React, { MouseEvent } from 'react';
import classNames from 'classnames';
import './HeaderActions.less';
import { useDisableAction } from 'hooks/useDisableAction';
import { HeaderAction, IHeaderActionProps } from './HeaderAction';
import { HasOpenState } from 'hooks/HasOpenState';

export type IHeaderSubAction = { name: string; action: () => void };

export type IHeaderAction = {
  iconClassName: string;
  title?: string;
} & ( // allow to pass either "action" or "subActions". Read more: https://maecapozzi.com/either-or-types/.
  | { action?: (event: MouseEvent<HTMLButtonElement>) => void; subActions?: never }
  | { subActions?: IHeaderActionProps['subActions']; action?: never }
);

export interface IHeaderActionsProps extends React.HTMLProps<HTMLDivElement> {
  actions: IHeaderAction[];
}

/**
 * Set of actions to edit column such as phrase or output. It is supposed to be used only for header cells.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function HeaderActions({ className, actions, ...otherProps }: IHeaderActionsProps) {
  const { disabledIds, handleClick } = useDisableAction();
  const { isOpen, setOpen, setClosed } = HasOpenState(false);

  const isEmpty = actions.length === 0;
  if (isEmpty) return null;

  return (
    <div
      className={classNames('tt-header-actions', className, {
        'tt-header-actions--active': isOpen,
      })}
      {...otherProps}
    >
      {actions.map((props, index) => (
        <HeaderAction
          key={`${props.iconClassName} ${index}`}
          disabled={disabledIds.includes(index)}
          iconClassName={props.iconClassName}
          onClick={props.action ? e => handleClick(e, props.action!, index) : undefined}
          subActions={props.subActions}
          title={props.title}
          onShowSubActions={setOpen}
          onHideSubActions={setClosed}
        />
      ))}
    </div>
  );
}
